import axios from 'axios';
import type { TpsAdminMetaData } from '~/types/api-types';

const METADATA_KEY = 'METADATA_KEY';

export async function getSystemMetaData() {
  try {
    const metadataJson = sessionStorage.getItem(METADATA_KEY);
    if (metadataJson === null) {
      const response = await axios.get('/api/metadata');
      const metadata = response.data as TpsAdminMetaData;
      sessionStorage.setItem(METADATA_KEY, JSON.stringify(metadata));
      return metadata;
    }
    return JSON.parse(metadataJson);
  } catch (error) {
    console.warn('Unable to retrieve system meta data');
    return null;
  }
}
